var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.5,
    width: 50,
    height: 50,
    rx: 8.75,
    fill: "#1EBFB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0938 14.1875H16.9062C15.5879 14.1875 14.5625 15.2617 14.5625 16.5312V33.7188C14.5625 35.0371 15.5879 36.0625 16.9062 36.0625H34.0938C35.3633 36.0625 36.4375 35.0371 36.4375 33.7188V16.5312C36.4375 15.2617 35.3633 14.1875 34.0938 14.1875ZM22.375 30.5938C22.375 31.0332 21.9844 31.375 21.5938 31.375H20.0312C19.5918 31.375 19.25 31.0332 19.25 30.5938V24.3438C19.25 23.9531 19.5918 23.5625 20.0312 23.5625H21.5938C21.9844 23.5625 22.375 23.9531 22.375 24.3438V30.5938ZM27.0625 30.5938C27.0625 31.0332 26.6719 31.375 26.2812 31.375H24.7188C24.2793 31.375 23.9375 31.0332 23.9375 30.5938V19.6562C23.9375 19.2656 24.2793 18.875 24.7188 18.875H26.2812C26.6719 18.875 27.0625 19.2656 27.0625 19.6562V30.5938ZM31.75 30.5938C31.75 31.0332 31.3594 31.375 30.9688 31.375H29.4062C28.9668 31.375 28.625 31.0332 28.625 30.5938V27.4688C28.625 27.0781 28.9668 26.6875 29.4062 26.6875H30.9688C31.3594 26.6875 31.75 27.0781 31.75 27.4688V30.5938Z",
    fill: "#48CFC5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolls);
export default __webpack_public_path__ + "static/media/polls.bb9d1806.svg";
export { ForwardRef as ReactComponent };